import { useCallback } from 'react';
import { useToast as useRocketToast } from '@totalsoft/rocket-ui';

export const useToast = () => {
  const addToast = useRocketToast();

  const fn = useCallback(
    (message, variant, { autoClose = true, ...rest } = {}) => {
      switch (variant) {
        case 'error': {
          addToast(message, 'error', { autoClose, ...rest });
          break;
        }
        case 'info': {
          addToast(message, 'info', { autoClose, ...rest });
          break;
        }
        case 'success':
          addToast(message, 'success', { autoClose, ...rest });
          break;
        case 'warning':
          addToast(message, 'warning', { autoClose, ...rest });
          break;
        default:
          addToast(message, undefined, { autoClose, ...rest });
          break;
      }
    },
    [addToast]
  );
  return fn;
};
